// Generated by CoffeeScript 2.7.0
var ShowRedPacketQuotasModal;

import RedPacketQuotasMixin from 'trunks/vue/admin/components/settings/settings_red_packet_quotas/mixin.js';

export default ShowRedPacketQuotasModal = Vue.extend({
  mixins: [RedPacketQuotasMixin],
  data: function() {
    return {
      allocatedAmountRecords: []
    };
  },
  template: `<modal title='详情' extendClass="show-red-packet-quotas-modal" ref="modal">
  <div class="modal-body">
    <template v-for="group in groups">
      <div class="group">
        <div class="group-title">{{ group.title }}</div>
        <div class="group-content">
          <template v-for="(item, key) in group.option">
            <div class="item">
              <div class="header">{{ item }}</div>
              <div class="value" v-if="key == 'name'">
                <user-item :user="redPacketQuotas.user"/>
              </div>
              <div class="slp-tooltip top" :data-title="redPacketQuotas[key]" v-else>
                <div class="value text-ellipsis">{{ redPacketQuotas[key] }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    
    <div class="group">
      <div class="group-title">额度修改记录</div>
      <div class="group-content">
        <div class="datable-table">
          <div class="table-responsive">
            <table class="table table-noborder table-striped" width="100%">
              <thead>
                <tr>
                  <th width="30%">修改时间</th>
                  <th width="20%">修改前剩余额度</th>
                  <th width="20%">新增/减少额度</th>
                  <th width="30%">备注</th>
                </tr>
              </thead>
            </table>
            <div class="scroll-body">
              <table>
                <tbody>
                  <template v-for="(record, index) in allocatedAmountRecords ">
                    <tr class="table-row">
                      <td width="30%">
                        <div class="row-cell text-ellipsis">{{ parseTime(record) }}</div>
                      </td>
                      <td width="20%">
                        <div class="row-cell text-ellipsis">{{ record.available_amount }}</div>
                      </td>
                      <td width="20%">
                        <div class="row-cell text-ellipsis">{{ record.allocated_amount  }}</div>
                      </td>
                      <td width="30%">
                        <div class="slp-tooltip top" :data-title="record.remark">
                          <div class="row-cell text-ellipsis remark">{{ record.remark }}</div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" slot="footer">
    <button @click='close'>关闭</button>
  </div>
</modal>`,
  created: function() {
    return Skylark.Libs.Ajax.get(`/admin/settings/red_packet_quotas/${this.initialRedPacketQuotas.id}`, {
      contentType: 'application/json; charset=utf-8',
      responseType: 'json',
      success: (data) => {
        return this.allocatedAmountRecords = data.allocations;
      }
    });
  },
  methods: {
    close: function() {
      return this.$refs.modal.close();
    },
    parseTime: function(record) {
      return new Date(record.created_at).strftime('YYYY-MM-DD hh:mm:ss');
    }
  }
});
